/* ============================================================
   Wido Ops — app entry.

   Import order matters and mirrors the original index.html load order:
     1. setup-globals  → puts React on window (must be first)
     2. design tokens + app stylesheet (Vite processes the @imports)
     3. data layer     → defines window.WidoData
     4. feature modules in dependency order → each attaches to window
     5. app.js         → defines window.WidoApp
   Each `import "./x.js"` is a side-effecting module (it assigns to
   window); none export bindings, so order is the contract.
   ============================================================ */
import "./setup-globals.js";

// i18n — patches React.createElement to auto-translate string children; load
// early (needs window.React from setup-globals) so every screen is covered.
import "./i18n.js";

// live API wiring — MUST come before the feature modules: they read
// window.WIDO_USE_API / WidoApi / WidoBootstrap at module-eval time.
import "./api/wire-globals.js";

// styles
import "./ds/styles.css";
import "./app.css";

// data (mock layer — always loaded for its pure helpers/constants/REQ_TYPES;
// in API mode the data fields are overwritten in place by the bootstrap)
import "./data.js";

// feature modules (same order as the design's index.html)
// tweaks-panel is .jsx (the one module authored in JSX); Vite transforms it.
import "./tweaks-panel.jsx";
import "./charts.js";
import "./notifications.js";
import "./auth.js";
import "./dashboard.js";
import "./requests.js";
import "./hr.js";
import "./admin.js";
import "./misc.js";
import "./employee-detail.js";
import "./teams.js";
import "./settings.js";
import "./holidays.js";
import "./devices.js";
import "./calendar.js";
import "./meetings.js";
import "./guide.js";
import "./hoursreport.js";
import "./system-settings.js";
import "./missing-clock.js";
import "./setup.js";
import "./push.js";
import "./app.js";

const { createRoot } = window.ReactDOMClient;
const React = window.React;

function mount() {
  if (!window.WidoApp) {
    // Modules evaluate synchronously on import, so WidoApp should already
    // exist; this guard just covers any future async module.
    setTimeout(mount, 30);
    return;
  }
  createRoot(document.getElementById("root")).render(React.createElement(window.WidoApp));
}
mount();

// Register the push service worker early so an already-subscribed browser keeps
// receiving notifications, and re-bind any existing subscription to the CURRENT
// user (so a shared machine never delivers a previous user's notifications).
if (window.WidoPush) { try { window.WidoPush.register(); window.WidoPush.resync(); } catch (e) {} }
